import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
const areas = [{
  title: 'Knowledge systems',
  body: 'Semantic relationships, source-grounded retrieval, curation and review.',
  href: '/semantic-knowledge',
  linkLabel: 'Semantic Knowledge Platform'
}, {
  title: 'Human capability',
  body: 'The Human Capability Framework, CJI, NCJI and the five pillars.',
  href: '/human-capability',
  linkLabel: 'Human Capability Framework'
}, {
  title: 'Studies and validation',
  body: 'Current research priorities and planned pilots, each labeled by status.',
  href: '#research-priorities',
  linkLabel: 'Research priorities'
}, {
  title: 'Publications',
  body: 'Publication plans, kept distinct from completed publications. None are published yet.',
  href: '/roadmap#publications',
  linkLabel: 'Publication plans'
}, {
  title: 'Future research',
  body: 'Exploratory research concepts, including civic ranking, universal leadership certification and emotion inference.',
  href: '#research-concepts',
  linkLabel: 'Research concepts'
}, {
  title: 'Roadmap',
  body: 'Current demos, development priorities and research milestones.',
  href: '/roadmap',
  linkLabel: 'Roadmap'
}];

/** Overview of how the research program is organized. */
export function ResearchMap() {
  return <section aria-labelledby="research-map-title" className="bg-surface-bg border-b border-line py-16 lg:py-20" data-id="element-1978" data-mp="3iwarpa20mmya">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1979" data-mp="3duv7tlbkqmhh">
        <motion.h2 {...fadeUp} id="research-map-title" className="font-heading font-bold text-3xl text-ink-dark tracking-tight mb-8" data-id="element-1980" data-mp="3rp602cms4ysa">
          How our research is organized
        </motion.h2>
        <motion.ol {...fadeUp} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1981" data-mp="2z70dk0hx4a2a">
          {areas.map((area, index) => <li key={area.title} className="flex flex-col bg-white p-6" data-id="element-1982" data-mp="y4ssdwka39zl" data-mpi={index}>
              <h3 className="flex items-center gap-3 font-heading font-bold text-lg text-ink-dark leading-snug" data-id="element-1983" data-mp="134neznx0tdeu">
                <span aria-hidden="true" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-teal/60 text-sm font-semibold text-teal" data-id="element-1984" data-mp="17vdlj4h6nmb4">
                  {index + 1}
                </span>
                {area.title}
              </h3>
              <p className="mt-2 mb-5 text-ink-muted leading-relaxed" data-id="element-1985" data-mp="k6kxdu6syir2">{area.body}</p>
              <a href={area.href} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1986" data-mp="p4cpopbd06vs">
                {area.linkLabel} <ArrowRight size={14} aria-hidden="true" data-id="element-1987" data-mp="25je2896vcr2v" />
              </a>
            </li>)}
        </motion.ol>
      </div>
    </section>;
}